export default __webpack_public_path__ + "static/logo-302ecc8e074e02fe30352ce0fc684b9d.png";